import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { isString, isNumber } from "@grandvisionhq/utils";
/* empty css                          */
const OrderOfPrescriptionAttributes = [
  "power",
  "baseCurve",
  "diameter",
  "axis",
  "cylinder",
  "addition"
];
const LineItemPrescription = ({ prescriptionAttrs }) => {
  const intl = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: "line-item__prescription" }, OrderOfPrescriptionAttributes.map((key) => {
    const value = prescriptionAttrs[key];
    return (isString(value) || isNumber(value)) && /* @__PURE__ */ React.createElement("span", { className: "line-item__prescription-item", key }, intl.getLabel(`products.contactLenses.prescription.${key}.abbr`) + ": ", value);
  }));
};
export {
  LineItemPrescription as default
};
//# sourceMappingURL=LineItemPrescription.js.map
